import {
  Settings,
  CropRotate,
  ViewInAr,
  // PieChart,
  // Code,
  // BarChart,
  CloudOutlined,
  FavoriteBorder,
  Public,
  PersonOutlined,
  AddLocationAltOutlined,
  PhoneIphone,
  EmailOutlined,
  Facebook,
  Twitter,
  Instagram,
  YouTube,
} from "@mui/icons-material";

export const navlink = [
  {
    url: "/",
    text: "Home",
  },
  {
    url: "/about",
    text: "About",
  },
  {
    url: "/services",
    text: "Services",
  },
  {
    url: "/portfolio",
    text: "Portfolio",
  },
  {
    url: "/testimonials",
    text: "Testimonials",
  },
  // {
  //   url: "/blog",
  //   text: "Blog",
  // },
  {
    url: "/contact",
    text: "Contact",
  },
];
export const home = [
  {
    text: "Hello I'm",
    name: "Esraa Mohammad",
    post: "Front End Developer",
    design: "Front End Developer",
    desc: "I am in love with front-end web development. I am a fast learner and Passionate for learning new technologies. I aim to learn professional processes of software development and work with a team according to structured standards in a productive environment.",
  },
];
export const about = [
  {
    desc:"I'm Esraa Mohammad.I am Expert in Web Development with lot of experience, Creatively develop your Website.A Frontend & Javascript Developer, with 2+ Years of Experience building and maintaining responsive websites. Proficient in HTML, CSS, jQuery, JavaScript, Bootstrap, SASS, React js, and modern libraries and frameworks. Passionate about usability and possess working knowledge of Adobe PhotoShop & Adobe XD ",
    desc1:"I'm Esraa Mohammad, a web developer where I can present to you developing the front end of the web, you will get design and write clean and responsive codes With all the screens from the largest to the smallest for the screens for phones, and all of this and more using Bootstrap and CSS and according to the Javascript frameworks, your project will be worked on using React js, I am pleased and honored to visit my profile.",
    cover: "./images/woman.png",
  },
];
export const services = [
  {
    id: 1,
    icon: <Settings />,
    title: "Creative Design",
    desc: " I can convert any XD, Figma, PSD, Illustrator Design to creative design",
  },
  {
    id: 2,
    icon: <CropRotate />,
    title: "Clean Code",
    desc: "And this is by writing a clean code with comments.",
  },
  {
    id: 3,
    icon: <ViewInAr />,
    title: "Responsive Design",
    desc: "I can build responsive web design for all devices mobile , tablet and desktop.",
  },
  // {
  //   id: 4,
  //   icon: <PieChart />,
  //   title: "Material UI	",
  //   desc: "Lorem Ipsum simply text of the printing and type setting industry when an unknown printing simply",
  // },
  // {
  //   id: 5,
  //   icon: <Code />,
  //   title: "Material UI Icons",
  //   desc: "Lorem Ipsum simply text of the printing and type setting industry when an unknown printing simply",
  // },
  // {
  //   id: 6,
  //   icon: <BarChart />,
  //   title: "Awesome Support",
  //   desc: "Lorem Ipsum simply text of the printing and type setting industry when an unknown printing simply",
  // },
];
export const project = [
  {
    id: 1,
    icon: <CloudOutlined />,
    num: "10",
    title: "HAPPY CLIENTS",
  },
  {
    id: 2,
    icon: <FavoriteBorder />,
    num: "15",
    title: "PROJECTS COMPLEATED",
  },
  {
    id: 3,
    icon: <Public />,
    num: "30",
    title: "FILES DOWNLOADED",
  },
  {
    id: 4,
    icon: <PersonOutlined />,
    num: "2000",
    title: "LINES OF CODE",
  },
];
export const portfolio = [
  {
    id: 20,
    cover: "../images/port/port20.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://ptgtourism.vercel.app/",
  },
  {
    id: 16,
    cover: "../images/port/port16.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://tuwaiq.vercel.app/",
  },
  {
    id: 17,
    cover: "../images/port/port17.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://navigation-company.vercel.app/",
  },
  {
    id: 3,
    cover: "../images/port/port13.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://souvenir-sepia.vercel.app/",
  },
  {
    id: 18,
    cover: "../images/port/port18.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://dubai-desert-safari.vercel.app/",
  },
  {
    id: 19,
    cover: "../images/port/port19.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://blog-system-three.vercel.app/",
  },
  {
    id: 1,
    cover: "../images/port/port1.png",
    name: "Brand",
    category: "marketing",
    title: "Brex Logo",
    url: "https://sparkling-custard-50288b.netlify.app/",
  },
  {
    id: 2,
    cover: "../images/port/port2.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://profound-blancmange-6b9b50.netlify.app/",
  },

  {
    id: 4,
    cover: "../images/port/port4.png",
    name: "Brand",
    category: "marketing",
    title: "Brex Logo",
    url: "https://boisterous-pie-496194.netlify.app/",
  },
  {
    id: 5,
    cover: "../images/port/port5.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://genuine-horse-e88b6d.netlify.app/",
  },
  {
    id: 6,
    cover: "../images/port/port6.png",
    name: "Brand",
    category: "development",
    title: "Brex Logo",
    url: "https://desiney-clone-bfvw4krvr-esraamohammadabdelmoteleb.vercel.app/",
  },
  {
    id: 7,
    cover: "../images/port/port7.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://mellifluous-halva-c75968.netlify.app/",
  },
  {
    id: 8,
    cover: "../images/port/port8.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://peaceful-macaron-c29b16.netlify.app/",
  },

  {
    id: 9,
    cover: "../images/port/port15.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://teal-dasik-e64469.netlify.app/",
  },
  {
    id: 10,
    cover: "../images/port/port10.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://rad-arithmetic-45bc64.netlify.app/",
  },
  {
    id: 11,
    cover: "../images/port/port11.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://effortless-kelpie-2473d4.netlify.app/",
  },
  {
    id: 12,
    cover: "../images/port/port12.png",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
    url: "https://sunny-raindrop-f2c2b4.netlify.app/",
  },
];
export const testimonials = [
  {
    id: 1,
    text: "The work on the Front-End is excellent! The pages are professionally designed, striking the perfect balance between aesthetics and functionality.",
    image: "./images/testimonials/team-1.png",
    name: "Ali Saad",
    post: "Front End Developer",
  },
  {
    id: 2,
    text: "The Front-End is amazing! Pages load quickly and are responsive on all devices, ensuring a seamless and user-friendly interaction with the website.",
    image: "./images/testimonials/team-2.png",
    name: "Ahmad Mostafa",
    post: "Back End Developer",
  },

];
export const blog = [
  {
    id: 1,
    title: "Master These Awesome",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been",
    cover: "./images/blog/b1.png",
  },
  {
    id: 2,
    title: "Best Design Items to Appeal",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been",
    cover: "./images/blog/b2.png",
  },
  {
    id: 3,
    title: "The 20 Best Lightroom Presets",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been",
    cover: "./images/blog/b3.png",
  },
];
export const contact = [
  {
    id: 0,
    icon: <AddLocationAltOutlined />,
    text1: "Gharbia, El-Mahalla El-Kubra City, Egypt",
    text2: "Seattle, WA, 98101",
  },
  {
    id: 1,
    icon: <PhoneIphone />,
    text1: "010885566778",
    text2: "0345627891",
  },
  {
    id: 2,
    icon: <EmailOutlined />,
    text1: "esraamohammad107@gmail.com",
    text2: "inf0@brex-theme.io",
  },
];
export const social = [
  {
    id: 0,
    icon: <Facebook />,
  },
  {
    id: 1,
    icon: <Twitter />,
  },
  {
    id: 2,
    icon: <Instagram />,
  },
  {
    id: 3,
    icon: <YouTube />,
  },
];
